import(/* webpackMode: "eager" */ "/codebuild/output/src3282395254/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
